import React from 'react';
import { useState } from 'react';
import { ThemeSetup } from '../../themes/ThemeSetup';
import './HelpIcon.css';
import classNames from 'classnames';
import ToolTip from '../AssetPropertyView';
import TooltipProperties from '../TooltipProperties'
import t from '../../i18n/I18n';

/**
 * 
 * @returns a functional HelpIcon Component which is to rendered at any place.
 */
function HelpIcon({ isSelected, onClick }) {

  return (
    <div className={isSelected ? classNames('help-icon-container', 'selected-container') : classNames('help-icon-container')}
      name='Help-Icon'>
        <ToolTip text={TooltipProperties.NavbarHelp} >
      <img className='help-icon' onClick={onClick}
        src={isSelected ? ThemeSetup.getImageURL('help/selected-help-icon.svg') : ThemeSetup.getImageURL('help/help-icon.svg')} />
        </ToolTip>
    </div>
  );
}

export default HelpIcon;
